import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { useQuery } from "react-query";

import { ReferentialItemDto } from "../../api";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface ICitySelectProps extends IFGSelectInputProps<any> {
  name: string;
  label?: string;
  postCode: number;
}

export const CitySelect: React.FunctionComponent<ICitySelectProps> = ({
  name,
  label,
  postCode,
  ...fgSelectInputProps
}) => {
  const { t, apis } = useCommonHooks();
  const { data, isFetching } = useQuery(
    [`ref-cities`, postCode],
    async () => {
      return apis.referential.localities(postCode);
    },
    { staleTime: Infinity }
  );

  return (
    <FGSelectInput
      label={label || t(ETLCodes.City)}
      name={name}
      items={data}
      loading={isFetching}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
